
import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ScrollIndicator = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [bounceActive, setBounceActive] = useState(true);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    // Controla a visibilidade e o estado do indicador
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Verifica se o usuário está próximo ao final da página
      const isNearBottom = scrollPosition + windowHeight >= documentHeight - 100;
      
      // Atualiza o estado para mostrar a seta para cima quando estiver no final
      setIsAtBottom(isNearBottom);
      
      // Esconde o indicador quando o usuário chegar ao final da página e rolar além
      if (scrollPosition + windowHeight >= documentHeight) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    // Desativa a animação bounce após 3 segundos
    const bounceTimer = setTimeout(() => {
      setBounceActive(false);
    }, 3000);

    window.addEventListener('scroll', handleScroll);
    
    // Limpa os event listeners e o timer quando o componente é desmontado
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(bounceTimer);
    };
  }, []);

  const handleClick = () => {
    if (isAtBottom) {
      // Rola para o topo da página
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // Calcula a próxima seção para onde rolar
      const currentPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const targetPosition = currentPosition + windowHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`fixed bottom-10 right-10 cursor-pointer ${!isAtBottom && bounceActive ? 'animate-bounce' : ''} z-50`}
      onClick={handleClick}
    >
      <div className="flex flex-col items-center">
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 shadow-md backdrop-blur-sm border border-purple-100">
          {isAtBottom ? (
            <ChevronUp size={28} className="text-purple-600" />
          ) : (
            <ChevronDown size={28} className="text-purple-600" />
          )}
        </div>
      </div>
    </div>
  );
};

export default ScrollIndicator;
